import { useNavigate } from 'react-router-dom';
import { attendTrackPageBreadcrumbs } from './config/breadcrumbs';
import { NavigateLinks } from '@/components';
import { icons } from '@/assets';

import styles from './AttendTrack.module.css';

export const AttendTrack = () => {
  const navigate = useNavigate();

  const breadcrumbs = attendTrackPageBreadcrumbs(navigate);

  return (
    <section className={styles.container}>
      <NavigateLinks
        actualPage='Monitoreo de agendas'
        breadcrumbs={breadcrumbs}
      />
      <ul className={styles.modules}>
        <li
          className={styles.module}
          onClick={() => navigate('prepare-package')}
        >
          <img src={icons.preparePackage} alt='Icono de Prepara Paquete' />
          <p>Preparar paquete</p>
        </li>
        <li className={styles.module} onClick={() => navigate('inbox')}>
          <img src={icons.inbox} alt='Icono de Buzón de Entrada' />
          <p>Buzón de entrada</p>
        </li>
        <li className={styles.module} onClick={() => navigate('agendas')}>
          <img src={icons.agenda} alt='Icono de Agenda' />
          <p>Agenda</p>
        </li>
        <li className={styles.module} onClick={() => navigate('/monitors')}>
          <img src={icons.monitor} alt='Icono de Monitor' />
          <p>Monitor</p>
        </li>
        <li className={styles.module} onClick={() => navigate('dashboard')}>
          <img src={icons.graphics} alt='Icono de Métricas' />
          <p>Métricas</p>
        </li> 
      </ul>
    </section>
  );
};
